import React from 'react';
import PropTypes from 'prop-types';
import noop from '../../../../utils/noop';

const getFileExtension = (fileName) => fileName.slice(fileName.lastIndexOf('.'));

class FileTrigger extends React.Component {
  constructor(props, state) {
    super(props, state);

    this.onFileChange = this.onFileChange.bind(this);
  }

  onFileChange({ target: { files } }) {
    this.checkExtensions(Array.from(files));
  }

  checkExtensions(fileList) {
    const { onChange, accept, onWrongTypeFile } = this.props;

    if (accept === 'all') {
      onChange(fileList);
      return;
    }

    const extensionsList = fileList.map(({ name }) => getFileExtension(name.toLowerCase()));
    const wrongExtensions = extensionsList.filter((extension) => !accept.includes(extension));
    const supportedFilesList = fileList.filter(
      ({ name }) => !wrongExtensions.includes(getFileExtension(name.toLowerCase()))
    );
    const dismissedFilesList = fileList.filter(({ name }) =>
      wrongExtensions.includes(getFileExtension(name.toLowerCase()))
    );

    if (wrongExtensions.length) {
      onWrongTypeFile(wrongExtensions, {
        supportedFilesList,
        dismissedFilesList,
      });
      return;
    }

    onChange(fileList);
  }

  render() {
    const { name, onClick, multiple, children, id, forwardRef } = this.props;

    return (
      <label htmlFor={id} className="file-trigger">
        <input
          type="file"
          name={name}
          id={id}
          className="file-trigger__input"
          onChange={this.onFileChange}
          onClick={onClick}
          multiple={multiple}
          ref={forwardRef}
        />
        {children}
      </label>
    );
  }
}

FileTrigger.defaultProps = {
  name: null,
  accept: 'all',
  multiple: false,
  children: null,
  onClick: noop,
  onWrongTypeFile: noop,
  onChange: noop,
  forwardRef: {
    current: undefined,
  },
};

FileTrigger.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  children: PropTypes.element,
  onClick: PropTypes.func,
  onWrongTypeFile: PropTypes.func,
  onChange: PropTypes.func,
  forwardRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
};

export default FileTrigger;
